import * as React from 'react';
import { Modal, UIHeading1 } from '@cian/ui-kit';
import { CPDModalContent } from '../../components/CPDModal';
import { useDispatch, useSelector } from 'react-redux';
import { selectCpdLandingUrl } from '../../selectors/cpd';
import { selectIsCPDModalOpen } from '../../selectors/cpd/selectIsCPDModalOpen';
import { setCpdModalOpen } from '../../actions/cpd/actions';
import { trackPopupItemClick } from './tracking';

export const CPDModalContainer: React.FC = () => {
  const isOpen = useSelector(selectIsCPDModalOpen);
  const cpdLandingLink = useSelector(selectCpdLandingUrl);

  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(setCpdModalOpen(false));
  }, [dispatch]);

  const handleSaleClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_sale');
    window.open(cpdLandingLink as string, '_self');
  }, []);

  const handleSaleToBuyClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_sale_to_buy');
    window.open(cpdLandingLink as string, '_self');
  }, []);

  const handleRentClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_rent');
    window.open('https://www.cian.ru/pik-arenda/ ', '_self');
  }, []);

  const handleOtherClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_other');
    window.open('https://www.cian.ru/podbor-rieltora/', '_self');
  }, []);

  if (!cpdLandingLink) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onOpenChange={handleClose}
      header={<UIHeading1 color="black_100">С чем нужна помощь риелтора?</UIHeading1>}
      body={
        <CPDModalContent
          onSaleClick={handleSaleClick}
          onSaleToBuyClick={handleSaleToBuyClick}
          onRentClick={handleRentClick}
          onOtherClick={handleOtherClick}
        />
      }
      footer={<div />}
    />
  );
};
